import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { toast } from "react-toastify";
import DropDownMulti from "./DropDownMulti";
import {
  SelectBox,
  Button as SelectBoxButton,
} from "devextreme-react/select-box";
import { DateBox, NumberBox, TextBox, TextArea } from "devextreme-react";
import { LoadPanel } from "devextreme-react/load-panel";
import { Button as TextBoxButton } from "devextreme-react/text-box";
import helpers from "../../../../assets/js/helper";

import moment from "moment";
import Cookies from "universal-cookie";
import axios from "../../../../assets/js/AxiosInterceptors";
import Host from "../../../../assets/js/Host";

import Grid from "@mui/material/Grid";

import CustomStore from "devextreme/data/custom_store";
import APP_CONSTANTS from "../../../../assets/js/constants";
import CustomTextField from "../../../../Components/CustomTextField";
import CustomeSelectField from "../../../../Components/CustomeSelectField";
import { debounce } from "debounce";
import { Box, Checkbox, FormControlLabel, TextField, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CachedIcon from '@mui/icons-material/Cached';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ContainerOfInputFields } from "../../../../Components/ThemDesign";
import { useSelector } from "react-redux";
import { SignalCellularNull } from "@mui/icons-material";
import CustomDatePicker from '../../../../Components/CustomDatePicker'
import { useTheme } from '@mui/material/styles';
const indicatorUrl =
  "https://js.devexpress.com/Content/data/loadingIcons/rolling.svg";

const cookies = new Cookies();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const isNotEmpty = (value) =>
  value !== undefined && value !== null && value !== "";
const useStyles = makeStyles(() => ({
  appBar: {
    position: "relative",
    backgroundColor: "#2e6b95",
  },
  title: {
    marginLeft: useTheme().spacing(2),
    flex: 1,
  },
  oddRow: {
    borderRadius: "5px",
    marginTop: useTheme().spacing(1),
    padding: useTheme().spacing(1),

    backgroundColor: "#ffffff",
  },
  evenRow: {
    borderRadius: "5px",
    marginTop: useTheme().spacing(1),
    padding: useTheme().spacing(1),
    backgroundColor: "#ffffff",
  },
  typographyClass: {
    fontFamily: "'Cairo'",
  },
  typographyOddClass: {
    fontFamily: "'Cairo'",
    color: "#2e6b95",
  },
  typographyEvenClass: {
    fontFamily: "'Cairo'",
    color: "#2e6b95",
  },
  containerHeader: {
    backgroundColor: "#f5f5f5",
  },
  innerContainerHeader: {
    paddingTop: useTheme().spacing(2),
    // paddingBottom: useTheme().spacing(1),

    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  firstColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#2e6b95",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  secondColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#2e6b95",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  thirdColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    textAlign: "center",
    padding: "15px",
    backgroundColor: "#e7e8e8",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  fourthColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    backgroundColor: "#e7e8e8",
    textAlign: "center",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    padding: "15px",
    color: "#2e6b95",
  },

  ColumnHeaders: {
    textAlign: "center",
    fontWeight: 600,

    margin: "0 auto",
  },

  container: {
    height: "100%",
    backgroundColor: "#f5f5f5",
    marginBottom: "100px",
  },
  innerContainer: {
    // paddingTop: useTheme().spacing(1),
    paddingBottom: useTheme().spacing(1),
    height: "100%",
    justifyContent: "space-around",
    backgroundColor: "#f5f5f5",
  },
  firstColumn: {
    borderRadius: "0px 0px 0px 0px",
    padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
  },
  secondColumn: {
    borderRadius: "0px 0px 0px 0px",
    padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px  rgba(0, 0, 0, 0.1)",
  },
  thirdColumn: {
    borderRadius: "0px 0px 5px 5px",
    textAlign: "center",
    padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
  },
  fourthColumn: {
    borderRadius: "0px 0px 5px 5px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    padding: "15px",
  },

  inner: {
    height: "125px",
    width: "250px",
    border: "1px solid black",
    borderRadius: "10%",
    margin: "0 auto",
    background: "#3f51b5",
  },

  mostInner: {
    textAlign: "center",
    height: "85px",
    width: "200px",
    border: "1px solid black",
    borderRadius: "50px",
    marginTop: "10px",
    marginLeft: "25px",
    marginRight: "25px",
    // boxShadow:"0px 0px 31px 2px #0083b3,inset 0px 0px 31px 2px #0083b3",
    //  textShadow:"0 0 5px #d4e3fa,  0 0 10px #d4e3fa, 0 0 7px #fff,  0 0 20px #8fb8f7, 0 0 35px #8fb8f7, 0 0 40px #8fb8f7, 0 0 50px #8fb8f7,  0 0 75px #8fb8f7",
    // background: "repeatingLinear-gradient(45deg,transparent,transparent 4px, #171717 4px, black 8px), linearGradient(to bottom, #171717, black)",
    background: "#f2f7ff",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
  },

  time: {
    color: "black",
    fontSize: "35px",
    position: "relative",
    display: "block",
    marginTop: "22px",
  },

  amPm: {
    position: "relative",
    display: "block",
    width: "10px",
    marginLeft: "150px",
    marginTop: "-5px",
    color: "black",
    fontSize: "12px",
  },
}));
export default function CCustomerCareDialog(props) {
  const dataSource = {
    remoteOperations: true,
    store: new CustomStore({
      // ...
      key: "customer_id",
      byKey: function (key) {
        key = key.length > 0 ? key[0] : key;
        var filter = JSON.stringify(["customer_id", "=", key]);

        return axios({
          url: Host + `customers/customer_by_id/` + key,
          method: "get",
          headers: props?.headers,
        })
          .then((data) => {
            setCustomerPhone(data?.data?.data[0].phone);
            return data?.data?.data;
          })
          .catch(() => {
            throw "Data Loading Error";
          });
      },

      load: function (loadOptions) {
        let params = "?";
        // Passing settings to the server

        // Pass if the remoteOperations property is set to true
        [
          "filter",
          "group",
          "groupSummary",
          "parentIds",
          "requireGroupCount",
          "requireTotalCount",
          "searchExpr",
          "searchOperation",
          "searchValue",
          "select",
          "sort",
          "skip",
          "take",
          "totalSummary",
          "userData",
        ].forEach(function (i) {
          if (i in loadOptions && isNotEmpty(loadOptions[i])) {
            params += `${i}=${JSON.stringify(loadOptions[i])}&`;
          }
        });
        params = params.slice(0, -1);
        return (
          axios({
            url: Host + `customers/page${params}`,
            method: "get",
            headers: props?.headers,
          })
            // return fetch(Host + `customers/page${params}`)
            .then((data) => {
              return data?.data;
            })
            .catch(() => {
              throw "Data Loading Error";
            })
        );
      },
    }),
  };

  const [customerPhone, setCustomerPhone] = useState(null);
  const maintheme = useSelector((state) => state.themedata?.maintheme);
  const classes = useStyles();

  const [data, setData] = useState({
    monitorSelected: [],
    assignedUsersSelected: [],
    weightSelected: "0",
    deadlineDateSelected: null,
    description: "",
    contactedNumber: "0",
    contactedPerson: "",
    customerId: null,
    customerName: "",
    customerDescription: "",
    closedStatus: false,
    realDate: new Date(),
  });
  const [customerSelectBoxOpen, setcustomerSelectBoxOpen] = useState(false);
  const [isLoadPanelVisible, setisLoadPanelVisible] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [tempDeadlineTime, setTempDeadLineTime] = useState(null);
  const [geoFences, setGeoFences] = useState([]);
  const [selectedGeoFences, setSelectedGeofences] = useState(null);
  const [selectedGovernorate, setSelectedGovernorate] = useState(null);
  const [geoFenceName, setGeoFenceName] = useState();
  const [selectedMonitored, setSelectedMonitored] = useState(null);
  const [selectedAssignTo, setSelectedAssignTo] = useState([]);
  const [selectedWorkType, setSelectedWorkType] = useState([]);
  const [description, setDescription] = useState("");

  const [phoneEerror, setPhoneError] = useState({
    err: false,
    message: "",
  });
  const handlePhoneError = (phone, isSubmit) => {
    let object = {
      err: false,
      message: "",
    };
    if (isNaN(phone)) {
      object = {
        ...object,
        err: true,
        message: "Invalid phone number format\n",
      };
    }
    if (!isNaN(phone) && (phone?.length > 11 || phone?.length < 11)) {
      object = {
        ...object,
        err: true,
        message: object?.message + "phone number must be 11 digit\n",
      };
    }
    if (!isNaN(phone)) {
      const pattern = /07[5-9][0-9]{8}/;
      if (!pattern.test(phone)) {
        object = {
          ...object,
          err: true,
          message:
            object?.message +
            "phone number format is not valid (ex:07x-x-xxxx-xxx)\n",
        };
      }
    }
    if (!phone) {
      object = {
        err: false,
        message: "",
      };
    }
    setPhoneError(object);
    if (isSubmit && !object?.err) {
      return true;
    }
  };

  const handleClose = () => {
    setData({
      monitorSelected: [],
      assignedUsersSelected: [],
      weightSelected: "0",
      deadlineDateSelected: null,
      description: "",
      numberOfUnits: "0",
      contactedNumber: "0",
      contactedPerson: "",
      customerId: null,
      customerName: "",
      customerDescription: "",
    });
    setSelectedAssignTo(null);
    setSelectedCustomer(null);
    setSelectedMonitored(null);
    setSelectedGeofences(null);
    setSelectedGovernorate(null);
    setSelectedWorkType(null);
    setCustomerPhone(null);
    props?.setcustomerID(null);
    props?.setOpenDialog(false);
  };
  const onSave = async () => {
    if (!handlePhoneError(data?.contactedNumber, true)) {
      return false;
    }
    if (!data?.customerId) {
      toast.error("Please, you must select a customer");
      return;
    }
    if (data?.monitorSelected?.length <= 0) {
      toast.error("Please, you must select a monitor");
      return;
    }
    if (data?.assignedUsersSelected?.length <= 0) {
      toast.error("Please, you must assign user(s)");
      return;
    }
    if (data?.contactedNumber?.length <= 0) {
      toast.error("Please, you must enter a contact number");
      return;
    }
    const pattern = /07[5-9][0-9]{8}/;
    if (!pattern.test(data?.contactedNumber)) {
      toast.error("phone number format is not valid (ex:07x-x-xxxx-xxx)");
      return;
    }
    if (data?.contactedPerson?.length <= 0) {
      toast.error("Please, you must enter a contact person name");
      return;
    }
    if (data?.description?.length <= 0) {
      toast.error("Please, you must enter a description for the task");
      return;
    }

    var headers = {
      jwt: cookies.get("token"),
    };

    setisLoadPanelVisible(true);
    const resultStatus = await helpers.checkIfCustomerHasOpenTask(
      data?.customerId,
      APP_CONSTANTS.CUSTOMER_CARE_TYPE,
      headers
    );

    if (resultStatus.status) {
      if (resultStatus.taskDetails?.length > 0) {
        var prepareMessage = "";
        if (resultStatus.taskDetails?.length == 1) {
          prepareMessage =
            "A task already open for this customer with id (" +
            resultStatus.taskDetails[0].task_id +
            "), status (" +
            resultStatus.taskDetails[0].status_name +
            "), created by (" +
            resultStatus.taskDetails[0].issuer_name +
            ") and description:" +
            resultStatus.taskDetails[0].description;
        } else {
          prepareMessage =
            "There are more than one task open for this customers, ids (" +
            resultStatus.taskDetails.map((item) => {
              return (
                resultStatus.taskDetails[0].issuer_name + "-" + item.task_id
              );
            }) +
            ")";
        }
        //console.log("execution time in the past")
        var result = window.confirm(
          prepareMessage + ", are you sure you want to continue?"
        );
        if (result == true) {
        } else {
          setData({
            monitorSelected: [],
            assignedUsersSelected: [],
            weightSelected: "0",
            deadlineDateSelected: null,
            description: "",
            governorateSelected: [],
            geoFenceSelected: [],
            workTypesSelected: [],

            numberOfUnits: "0",
            contactedNumber: "0",
            contactedPerson: "",
            customerId: null,
            customerName: "",

            customerDescription: "",
            realDate: new Date(),
          });
          setCustomerPhone(null);
          props?.setcustomerID(null);
          setisLoadPanelVisible(false);
          props?.setOpenDialog(false);
          toast.error("operation canceled");
          return;
        }
      }
    }
    let create_path = `Back-${Host + `tasks/customer_care`} , Front:${window
      .location.origin + window.location.pathname}`;
    if(!isLoadPanelVisible) {
      axios({
        url: Host + `tasks/customer_care`,
        method: "POST",
        headers: headers,
        data: { 
          ...data, 
          realDate:data?.realDate?helpers.formatDate(data?.realDate):null,
          create_path: create_path },
      })
        .then((res) => {
          if (res.data?.status === true) {
            setData({
              monitorSelected: [],
              assignedUsersSelected: [],
              weightSelected: "0",
              deadlineDateSelected: null,
              description: "",
  
              numberOfUnits: "0",
              contactedNumber: "0",
              contactedPerson: "",
              customerId: null,
              customerName: "",
              customerDescription: "",
              realDate: new Date(),
            });
            setCustomerPhone(null);
            props?.setcustomerID(null);
  
            setisLoadPanelVisible(false);
            props?.setOpenDialog(false);
            props?.reload();
  
            toast.success("Task Created successfully");
          } else if (res.data?.status === false) {
            toast.error(res.data?.data?.message.text);
            props?.setOpen(false);
          }
        })
        .catch((err) => {
          toast.error("Network Error");
          //console.log(err)
          setisLoadPanelVisible(false);
        });
    }
  };

  const weightChanged = (event) => {
    if (event && event.value) {
      setData({
        ...data,
        weightSelected: event.value,
      });
    } else {
      setData({
        ...data,
        weightSelected: 0,
      });
    }
  };
  const onDeadlineDateChanged = (date) => {
    if (date) {
      setTempDeadLineTime(date);
      var date =helpers?.formatDate(date)+' '+helpers.formatTime(date)
      setData({
        ...data,
        deadlineDateSelected: date,
      });
    } else {
      setTempDeadLineTime(null);
      setData({
        ...data,
        deadlineDateSelected: null,
      });
    }
  };

  const descriptionChanged = (event) => {
    if (event && event.value) {
      setData({
        ...data,
        description: event?.value ? event?.value?.replace(/'/g, "") : "",
      });
    } else {
      setData({
        ...data,
        description: "",
      });
    }
  };
  const contactedNumberChanged = (event) => {
    if (event && event.value) {
      setData({
        ...data,
        contactedNumber: event.value,
      });
    } else {
      setData({
        ...data,
        contactedNumber: "",
      });
    }
  };
  const contactedPersonChanged = (event) => {
    if (event && event.value) {
      setData({
        ...data,
        contactedPerson: event?.value ? event?.value?.replace(/'/g, "") : "",
      });
    } else {
      setData({
        ...data,
        contactedPerson: "",
      });
    }
  };

  useEffect(() => {
    var monitoredSelected = [];
    var assignersSelected = [];

    monitoredSelected = props?.selectedCustomerCareFields?.monitor;
    assignersSelected = props?.selectedCustomerCareFields?.assigners;
    if (data?.assignedUsersSelected?.length > 0) {
      assignersSelected = data?.assignedUsersSelected;
    }
    if (data?.monitorSelected?.length > 0) {
      monitoredSelected = data?.monitorSelected;
    }

    let object = null;
    if (data?.monitorSelected)
      props?.monitors?.map((itm) => {
        if (itm?.user_id == data?.monitorSelected[0]) object = itm;
      });
    setSelectedMonitored(object);
    let arr = [];
    props?.assigners &&
      props?.assigners?.length > 0 &&
      props?.assigners?.map((itm) => {
        if (data?.assignedUsersSelected?.includes(itm.user_id)) {
          arr.push(itm);
        }
      });
    setSelectedAssignTo(arr);
  }, [props?.monitors, props?.assigners]);

  useEffect(() => {
    console.log("entered here 1 INSTALLATION");
    console.log("propsprops", props);

    loadDataOfCustomers();
    // const defaultSettings = JSON.parse(localStorage.getItem('defaultSettings'))
    var monitoredSelected = [];
    var assignersSelected = [];

    monitoredSelected = props?.selectedCustomerCareFields?.monitor;
    assignersSelected = props?.selectedCustomerCareFields?.assigners;

    // to avoid reset these values when editing a customer
    if (data?.assignedUsersSelected?.length > 0) {
      assignersSelected = data?.assignedUsersSelected;
    }
    if (data?.monitorSelected?.length > 0) {
      monitoredSelected = data?.monitorSelected;
    }
    setCustomerPhone(null);

    setData({
      ...data,
      monitorSelected: monitoredSelected,
      assignedUsersSelected: assignersSelected,
      customerId: props?.customerID,
    });
    props?.setAssigners(
      props?.assigners?.map((item) => {
        return {
          name: item.name,
          user_id: item.user_id,
          selected: data?.assignedUsersSelected?.includes(item.user_id),
        };
      })
    );
    props?.setMonitors(
      props?.monitors?.map((item) => {
        return {
          name: item.name,
          user_id: item.user_id,
          selected: data?.monitorSelected?.includes(item.user_id),
        };
      })
    );
    const timer = setTimeout(() => {
      setData({
        ...data,
        monitorSelected: monitoredSelected,
        assignedUsersSelected: assignersSelected,
        customerId: props?.customerID,
      });
      props?.setAssigners(
        props?.assigners?.map((item) => {
          return {
            name: item.name,
            user_id: item.user_id,
            selected: data?.assignedUsersSelected?.includes(item.user_id),
          };
        })
      );
      props?.setMonitors(
        props?.monitors?.map((item) => {
          return {
            name: item.name,
            user_id: item.user_id,
            selected: data?.monitorSelected?.includes(item.user_id),
          };
        })
      );
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [props?.openDialog]);

  const onSelectedAssignedUsersTypeKeysChange = (args) => {
    if (args && args?.length > 0) {
      setData({
        ...data,
        assignedUsersSelected: args,
      });
    } else {
      setData({
        ...data,
        assignedUsersSelected: [],
      });
    }
  };
  const onSelectedMonitorUsersTypeKeysChange = (args) => {
    if (args) {
      setData({
        ...data,
        monitorSelected: args,
      });
    } else {
      setData({
        ...data,
        monitorSelected: [],
      });
    }
  };
  const copyPhoneButton = {
    icon: "copy",
    type: "default",
    disabled: false,
    onClick: () => {
      const customerPhoneTemp = customerPhone;
      setData({
        ...data,
        contactedNumber: customerPhoneTemp,
      });
    },
  };
  const editCustomerButton = {
    icon: "edit",

    onClick: () => {
      if (props?.customerID > 0) {
        axios({
          url: Host + `customers/customer_by_id/` + props?.customerID,
          method: "get",
          headers: props?.headers,
        })
          .then((data) => {
            //console.log(data?.data?.data);
            if (data?.data?.data && data?.data?.data?.length > 0) {
              props?.setEditCustomer(data?.data?.data[0]);
              props?.setOpenDialog(false);
              props?.setpopupVisible(true);
            } else {
              toast.error("coudn't find the selected customer");
              return;
            }
          })
          .catch(() => {
            toast.error("Error in getting the selected customer");
            return;
          });
      } else {
        toast.error("Please select a customer to edit ");
        return;
      }
    },
  };
  const editCustomerFunction = () => {
    if (props?.customerID > 0) {
      axios({
        url: Host + `customers/customer_by_id/` + props?.customerID,
        method: "get",
        headers: props?.headers,
      })
        .then((data) => {
          //console.log(data?.data?.data);
          if (data?.data?.data && data?.data?.data?.length > 0) {
            props?.setEditCustomer(data?.data?.data[0]);
            props?.setOpenDialog(false);
            props?.setpopupVisible(true);
          } else {
            toast.error("coudn't find the selected customer");
            return;
          }
        })
        .catch(() => {
          toast.error("Error in getting the selected customer");
          return;
        });
    } else {
      toast.error("Please select a customer to edit ");
      return;
    }
  };
  const addCustomerButton = {
    icon: "add",

    onClick: () => {
      props?.setEditCustomer(null);
      props?.setOpenDialog(false);
      props?.setpopupVisible(true);
    },
  };

  const onSelectedCustomerKeysChange = (args) => {
    props?.setcustomerID(args.value);

    dataSource.store.byKey(args.value).then(
      (dataItem) => {
        /* Process the "dataItem" here */

        setCustomerPhone(dataItem[0].phone);
        setData({
          ...data,

          customerId: args.value,
        });
      },
      (error) => {
        /* Handle the "error" here */
        //console.log(error)
      }
    );

    // setData({
    //     ...data,
    //     customerId: args.value
    // });
  };
  const rules = { X: /[02-9]/ };

  const handleHide = () => {
    setisLoadPanelVisible(false);
  };

  useEffect(() => {
    return () => { };
  }, []);

  const loadDataOfCustomers = async (searchParams) => {
    let data = null;
    let params = 'searchOperation="contains"&userData={}&';
    let paramsList = [];
    try {
      if (searchParams && searchParams?.length > 0) {
        params +=
          'searchExpr="' +
          searchParams[0] +
          '"&searchValue="' +
          searchParams[1] +
          '"&';
      }
      params += 'is_add_or_update=1'
      data = await axios({
        url: Host + `customers/page?${params}`,
        method: "get",
        headers: props?.headers,
      })
        // return fetch(Host + `customers/page${params}`)
        .then((data) => {
          ////console.log(data?.data)
          setCustomers(data?.data?.data);
        });
    } catch (err) {
      console.log(err?.message);
    }
  };
  const handleCustomerSearch = debounce((value) => {
    let searchParams = ["customer_name", value];
    loadDataOfCustomers(searchParams);
  }, 500);

  const copyPhoneFunction = () => {
    const customerPhoneTemp = customerPhone;
    setData({
      ...data,
      contactedNumber: customerPhoneTemp,
    });
  };
  useEffect(() => {
    console.log("data chnaged", data);
  }, [data]);

  return (
    <div>
      <Dialog
        fullScreen
        open={props?.openDialog}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{
          backgroundColor: "#f5f5f5",
          "& .MuiPaper-root": {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        <AppBar
          sx={{
            backgroundColor: "#1e6a99 !important",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6">Create Customer Care Task</Typography>
            </Box>
            <Button autoFocus color="inherit" onClick={onSave}>
              Save
            </Button>
          </Toolbar>
        </AppBar>
        <Grid
          container
          className={classes.container}
          sx={{
            marginTop: "60px",
            backgroundColor: "#fff",
          }}
        >
          <Grid item xs={12} className={classes.innerContainerHeader}>
            <Grid container className={classes.innerContainerHeader}>
              <Grid item xs={5} className={classes.firstColumn}>
                <Grid container sx={{ marginTop: "15px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <CustomeSelectField
                      label={"Customer"}
                      customWidth="100%"
                      haswidth={true}
                      value={selectedCustomer}
                      list={customers ? customers : []}
                      customGetOptionLabel={(option) => option?.customer_name}
                      error={false}
                      message={[]}
                      multiple={false}
                      readOnly={false}
                      onSearch={(value) => {
                        if (value?.target.value)
                          handleCustomerSearch(value?.target.value);
                      }}
                      focused={true}
                      onChange={(e, newValue) => {
                        console.log("newValue", newValue);
                        setSelectedCustomer(newValue);
                        props?.setcustomerID(newValue?.customer_id);
                        setCustomerPhone(newValue?.phone);
                        setData({
                          ...data,
                          customerId: newValue?.customer_id,
                        });
                      }}
                      onClearClick={() => {
                        setSelectedCustomer(null);
                        props?.setcustomerID(null);
                        setCustomerPhone(null);
                        setData({
                          ...data,
                          customerId: null,
                        });
                      }}
                    />
                    {/* <Tooltip arrow title={"Edit Customer"}>
                        <IconButton
                          onClick={editCustomerFunction}
                          sx={{
                            backgroundColor: "#fff",
                            boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                            marginRight: "5px",
                          }}
                        >
                          <EditIcon sx={{ color: "#000" }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip arrow title={"Add Customer"}>
                        <IconButton
                          onClick={() => {
                            props?.setEditCustomer(null);
                            props?.setOpenDialog(false);
                            props?.setpopupVisible(true);
                          }}
                          sx={{
                            backgroundColor: "#fff",
                            boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                          }}
                        >
                          <AddIcon sx={{ color: "#000" }} />
                        </IconButton>
                      </Tooltip> */}
                    <Tooltip arrow title={"Sync Customers with ERP"}>
                      <IconButton
                        onClick={async () => {
                          let response = await helpers.handleSyncCustomers()
                          if (response) {
                            loadDataOfCustomers()
                          }
                        }}
                        sx={{
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                        }}
                      >
                        <CachedIcon sx={{ color: "#000" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid container sx={{ marginTop: "22px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <CustomTextField
                      label={"Customer phone"}
                      haswidth={true}
                      value={customerPhone}
                      error={false}
                      customWidth="100%"
                      hasMultipleLine={false}
                      // paddingHorizontal="2px 10px 2px 5px !important"
                      message={""}
                      readOnly={true}
                    />
                    <Tooltip arrow title={"Copy phone"}>
                      <IconButton
                        onClick={copyPhoneFunction}
                        sx={{
                          backgroundColor: "#fff",
                          boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                        }}
                      >
                        <ContentCopyIcon sx={{ color: "#000" }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
                <Grid container sx={{ marginTop: "22px" }}>
                  {/* <Grid item xs={12}> */}
                  <CustomTextField
                    label={"Weights"}
                    haswidth={true}
                    value={data?.weightSelected}
                    error={false}
                    customWidth="100%"
                    hasMultipleLine={false}
                    type="number"
                    onChange={(e) => {
                      if (e?.target?.value <= 10) {
                        weightChanged(e?.target);
                      }
                    }}
                    onClearClick={() => {
                      weightChanged(null);
                    }}
                    message={""}
                    readOnly={false}
                  />
                  {/* </Grid> */}
                </Grid>
                <Grid container sx={{ marginTop: "20px" }}>
                  <ContainerOfInputFields
                    mainTheme={maintheme}
                    customeWidth={"100%"}
                    hasError={false}
                    haswidth={true}
                    isForm={true}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        margin: "5px 0",
                        width: "100%",
                        backgroundColor: "#fff",
                      }}
                      className=" orderdata"
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          label={"DeadLine Time"}
                          inputFormat="MM/DD/YYYY HH:mm:ss"
                          value={
                            tempDeadlineTime
                              ? tempDeadlineTime
                              : data?.deadlineDateSelected
                          }
                          // minDate={new Date()}
                          inputProps={{
                            placeholder: "not specified yet",
                          }}
                          onChange={(date) => onDeadlineDateChanged(date)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              focused={true}
                              className={``}
                              inputProps={{
                                ...params.inputProps,
                                placeholder: "not specified yet",
                              }}
                            />
                          )}
                        />
                        {data?.deadlineDateSelected || tempDeadlineTime ? (
                          <CloseIcon
                            className="closeIcon"
                            onClick={() => onDeadlineDateChanged(null)}
                            sx={{
                              right: "37px !important",
                              top: "14px !important",
                            }}
                          />
                        ) : null}
                      </LocalizationProvider>
                    </Box>
                  </ContainerOfInputFields>

                </Grid>
                <Grid container sx={{ marginTop: "5px" }}>
                  <Box sx={{ width: '100%', padding: '0 10px', height: 'fit-content' }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        boxShadow: '0 0 7px -2px #000',
                        height: '55px',
                        padding: '0 5px',
                        width: '100%',
                        borderLeft: '5px solid #1e6a99'
                      }}
                    >
                      <FormControlLabel
                        sx={{
                          width: '100%',
                        }}
                        control={<Checkbox
                          checked={data?.closedStatus}
                          onChange={() => {
                            setData({
                              ...data,
                              closedStatus: !data?.closedStatus,
                            });
                          }}
                        />} label="Closed" />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={5} className={classes.firstColumn}>
                <Grid container className={classes.oddRow}>
                  <Grid item xs={12}>
                    <CustomeSelectField
                      label={"Monitored By"}
                      customWidth="100%"
                      haswidth={true}
                      value={selectedMonitored}
                      list={props?.monitors ? props?.monitors : []}
                      customGetOptionLabel={(option) => option?.name || ""}
                      error={false}
                      message={[]}
                      multiple={false}
                      readOnly={false}
                      focused={true}
                      onChange={(e, newValue) => {
                        setSelectedMonitored(newValue);
                        onSelectedMonitorUsersTypeKeysChange([
                          newValue?.user_id,
                        ]);
                      }}
                      onClearClick={() => {
                        setSelectedMonitored(null);
                        onSelectedMonitorUsersTypeKeysChange(null);
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container className={classes.evenRow}>
                  <Grid item xs={12}>
                    <CustomeSelectField
                      label={"Assigned To"}
                      customWidth="100%"
                      haswidth={true}
                      value={selectedAssignTo ? selectedAssignTo : []}
                      list={props?.assigners ? props?.assigners : []}
                      customGetOptionLabel={(option) => option?.name || ""}
                      error={false}
                      message={[]}
                      multiple={true}
                      readOnly={false}
                      focused={true}
                      onChange={(e, newValue) => {
                        setSelectedAssignTo(newValue);
                        onSelectedAssignedUsersTypeKeysChange([
                          ...newValue?.map((itm) => itm?.user_id),
                        ]);
                      }}
                      onClearClick={() => {
                        setSelectedAssignTo(null);
                        onSelectedAssignedUsersTypeKeysChange(null);
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container className={classes.oddRow}>
                  <Grid item xs={12}>
                    <CustomTextField
                      label={"Contact phone"}
                      haswidth={true}
                      value={data?.contactedNumber}
                      error={phoneEerror?.err}
                      errorMessage={phoneEerror?.message}
                      customWidth="100%"
                      hasMultipleLine={false}
                      onChange={(e) => {
                        if (!isNaN(e?.target?.value))
                          contactedNumberChanged(e?.target);
                        handlePhoneError(e?.target?.value);
                      }}
                      onClearClick={() => {
                        contactedNumberChanged("");
                        handlePhoneError("");
                      }}
                      // paddingHorizontal="2px 10px 2px 5px !important"
                      message={""}
                      readOnly={false}
                    />
                  </Grid>
                </Grid>

                <Grid container className={classes.evenRow}>
                  <Grid item xs={12}>
                    <CustomTextField
                      label={"Enter full name"}
                      haswidth={true}
                      value={data?.contactedPerson}
                      error={false}
                      customWidth="100%"
                      hasMultipleLine={false}
                      onChange={(e) => {
                        contactedPersonChanged(e?.target);
                      }}
                      onClearClick={() => {
                        contactedPersonChanged("");
                      }}
                      message={""}
                      readOnly={false}
                    />
                  </Grid>
                </Grid>
                <Grid container sx={{ marginTop: "20px",padding:'0 18px' }}>
                  <CustomDatePicker
                    label={"Actual Date"}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    customWidth="100%"
                    paddingHorizontal="0"
                    value={data?.realDate}
                    is_dateTime={false}
                    error={false}
                    textError={''}
                    setValue={(date) => {
                      setData({
                        ...data,
                        realDate:date
                      })
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                xs={10}
                className={classes.firstColumn}
                sx={{ marginTop: "-10px" }}
              >
                <CustomTextField
                  label={"Descriptions"}
                  haswidth={true}
                  value={description}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={true}
                  // paddingHorizontal="2px 10px 2px 5px !important"
                  message={""}
                  readOnly={false}
                  onChange={(e) => {
                    setDescription(e?.target?.value);
                    descriptionChanged(e?.target);
                  }}
                  onClearClick={() => {
                    setDescription("");
                    descriptionChanged("");
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div style={{ marginBottom: "100px" }}></div>
      </Dialog>
    </div>
  );
}
